<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="24" :md="22" :lg="20" :xl="16">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-position="top"
          size="large"
        >
          <el-row :gutter="10">
            <el-col :span="24">
              <fieldset class="form-fieldset">
                <legend>Qator sarlavhasi (barcha tillarda)</legend>
                <el-tabs v-model="activeLang" class="lang-tabs">
                  <el-tab-pane v-for="lt in langTabs" :key="lt.code" :name="lt.code">
                    <template #label>
                      <span class="lang-tab-label" :class="{'lang-tab-label--error': langErrors.includes(lt.code)}">
                        {{ lt.tabLabel }}
                        <span v-if="!form.order_title[lt.code]" class="lang-tab-dot" title="Bo'sh"/>
                      </span>
                    </template>
                    <el-form-item :label="titleLangLabels[lt.code]" :prop="'order_title.' + lt.code">
                      <el-input
                        v-model="form.order_title[lt.code]"
                        :placeholder="titleLangLabels[lt.code]"
                        clearable
                        @input="clearLangError(lt.code)"
                      />
                    </el-form-item>
                  </el-tab-pane>
                </el-tabs>
              </fieldset>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="8">
              <el-form-item label="Qator havolasi" prop="order_link">
                <el-input
                  placeholder="Qator havolasi"
                  controls-position="right"
                  class="form-input"
                  v-model="form.order_link"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="8">
              <el-form-item label="Budjet yili" prop="budget_year">
                <el-input-number
                  placeholder="Budjet yili"
                  controls-position="right"
                  class="form-input"
                  v-model="form.budget_year"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="8">
              <el-form-item label="Daromaad" prop="income">
                <el-input-number
                  placeholder="Daromad"
                  controls-position="right"
                  class="form-input"
                  v-model="form.income"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="8">
              <el-form-item label="Xarajat" prop="outcome">
                <el-input-number
                  placeholder="Xarajat"
                  controls-position="right"
                  class="form-input"
                  v-model="form.outcome"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                  >Orqaga</el-button
                >
                <el-button class="custom-btn" type="primary" @click="onSubmit"
                  >Saqlash</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ElMessage, ElNotification } from "element-plus";
import { API_BASE, HL_HEADER, LANG_TABS, TITLE_LANG_LABELS } from "./constants";

export default {
  name: "BudgetParamsForm",
  data() {
    return {
      loading: false,
      editId: null,
      activeLang: "uz_lat",
      langErrors: [],
      langTabs: LANG_TABS,
      titleLangLabels: TITLE_LANG_LABELS,
      form: {
        order_title: {
          uz_cyr: null,
          uz_lat: null,
          kr: null,
          en: null,
          ru: null,
        },
        order_link: null,
        budget_year: null,
        income: null,
        outcome: null,
      },
      rules: {
        budget_year: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
        ],
        income: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
        ],
        outcome: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
        ],
        order_title: {
          uz_lat: [{ required: true, message: "Majburiy maydon", trigger: "blur" }],
          uz_cyr: [{ required: true, message: "Majburiy maydon", trigger: "blur" }],
          ru: [{ required: true, message: "Majburiy maydon", trigger: "blur" }],
          en: [{ required: true, message: "Majburiy maydon", trigger: "blur" }],
          kr: [{ required: true, message: "Majburiy maydon", trigger: "blur" }],
        },
      },
    };
  },
  methods: {
    clearLangError(code) {
      this.langErrors = this.langErrors.filter((c) => c !== code);
    },
    getBudgetParam() {
      this.loading = true;
      this.$http
        .get(`${API_BASE}/${this.editId}/full`, { headers: HL_HEADER })
        .then(({ data }) => {
          this.form.order_link = data.order_link;
          this.form.budget_year = data.budget_year;
          this.form.income = data.income;
          this.form.outcome = data.outcome;
          this.form.order_title = { ...this.form.order_title, ...data.order_title };
        })
        .catch(({ response }) => {
          ElNotification.error({
            message:
              response.data.message ||
              "Ma'lmumot yuklasda xatolik sodir bo'ldi!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmit() {
      this.langErrors = [];
      this.$refs.form.validate((valid, invalidFields) => {
        if (valid) {
          this.loading = true;

          let http;

          const formData = { ...this.form };

          if (this.editId) {
            http = this.$http.put(`${API_BASE}/${this.editId}`, formData);
          } else {
            http = this.$http.post(API_BASE, formData);
          }

          http
            .then(() => {
              ElNotification({
                title: "Tabriklaymiz",
                message: "Muvafaqiyatli saqlandi",
                type: "success",
              });
              this.$router.go(-1);
            })
            .catch(({ response }) => {
              ElNotification({
                title: "Xatolik",
                message:
                  response.data.message || "Iltimos, qayta urinib ko'ring.",
                type: "error",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          ElMessage.error("Iltimos, majburiy maydonlarni to'ldiring");
          if (invalidFields) {
            this.langErrors = Object.keys(invalidFields)
              .filter((key) => key.startsWith("order_title."))
              .map((key) => key.split(".")[1]);
            const firstInvalidLang = this.langErrors[0];
            if (firstInvalidLang) this.activeLang = firstInvalidLang;
          }
        }
      });
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.editId = this.$route.params.id;
      this.getBudgetParam();
    }
  },
};
</script>

<style scoped>
.form-input {
  width: 100%;
}

.form-fieldset {
  border: 1px solid var(--el-border-color);
  border-radius: 4px;
  padding: 0 12px 12px;
  margin-bottom: 18px;
}

.form-fieldset legend {
  padding: 0 6px;
  font-size: 13px;
  color: var(--el-text-color-secondary);
}

.lang-tabs {
  margin-bottom: 4px;
}

.lang-tab-label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.lang-tab-label--error {
  color: #f56c6c;
}

.lang-tab-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #e6a23c;
  flex-shrink: 0;
}
</style>
